module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 46
// module chunks = 0